import React, { Component } from 'react';
import { connect } from 'react-redux';
import { sendApiPaySms } from './redux';
import LeftNavigation from 'components/layout/LeftNavigation';
class AboutContent extends Component {
  state = {
    title:'关于我们'
  }
  componentDidMount(){
  }
  render() {

    var menuList = [
      {
        content:'公司介绍',
        link:'/company',
        current:true
      },
      {
        content:'股东介绍',
        link:'/shareholder'
      },
      {
        content:'高管团队',
        link:'/managers'
      },
      {
        content:'新闻动态',
        link:'/news'
      },
      {
        content:'合作机构',
        link:'/cooperater'
      },
      {
        content:'门店地址',
        link:'/address'
      },
    ];
    return(

      <div className="wrap product_Detail" id="page_Detail">{/**关于我们*/}
        <div className="mg-auto area clearfix">
          <LeftNavigation title={this.state.title} menuList={menuList}/>
          <div class='right'>{this.props.child}</div>
        </div>
      </div>
    );
  }
}
AboutContent = connect(state => ({
}), {
  sendSms: sendApiPaySms
})(AboutContent);
export default AboutContent;



// WEBPACK FOOTER //
// ./modules/aboutUs/AboutContent.js